import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import * as Text from 'theme/components/Text.style';

interface MicrophoneProps {
  active?: boolean;
}

interface ButtonProps {
  disabled?: boolean;
}

export const Section = styled('div')`
  align-items: flex-end;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0;
  width: 100%;
`;

export const Chatbar = styled(Paper)`
  align-items: center;
  background-color: white;
  border-radius: 20px;
  box-sizing: border-box;
  box-shadow: none;
  display: flex;
  justify-content: space-between;
  padding: 6px 12px;
  width: 100%;
`;

export const Microphone = styled(IconButton)<MicrophoneProps>`
  margin-right: 10px;

  svg path {
    stroke: ${(props) =>
      props.active ? colours.primary[500] : colours.neutral[700]};
  }
`;

export const Button = styled(IconButton)<ButtonProps>`
  svg path {
    stroke: ${(props) =>
      props.disabled ? colours.neutral[700] : colours.primary[500]};
  }
`;

export const Disclaimer = styled(Text.Label)`
  margin-top: 4px;
  text-align: center;
  width: 100%;
`;

export const Link = styled('a')`
  color: ${colours.neutral[400]};
  text-decoration: underline;
  &:hover {
    color: ${colours.neutral[500]};
  }
`;
